export * from "./auth.service";
export * from "./whitelabel.service";
export * from './counsellors.service';
export * from './appVersion.service';
export * from './reportsService';
export * from './patient.services';
export * from './appointment.service';


// WEBPACK FOOTER //
// ./src/services/index.js